export default __webpack_public_path__ + "static/media/Mysore_Bandipur.f8155647.jpg";